import gql from 'graphql-tag';

export const ALL_SFR_REASONS = gql`
  query {
    allSfrReasons {
      id
      name
      priorityOrder
    }
  }
`;
